import type { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary" | "ghost" | "quiet";

const classFor = (variant: Variant, block?: boolean, extra?: string) =>
  ["btn", `btn--${variant}`, block ? "btn--block" : "", extra ?? ""].filter(Boolean).join(" ");

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  block?: boolean;
  pending?: boolean;
  children: ReactNode;
}

export function Button({
  variant = "primary",
  block,
  pending,
  className,
  children,
  disabled,
  ...rest
}: ButtonProps) {
  return (
    <button
      type="button"
      className={classFor(variant, block, className)}
      disabled={disabled || pending}
      {...rest}
    >
      {pending ? <span className="spinner" aria-hidden="true" /> : null}
      {children}
    </button>
  );
}

interface ExternalButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: Variant;
  block?: boolean;
  children: ReactNode;
}

/** An external link styled as a button. Opens in a new tab. */
export function ExternalButton({
  variant = "primary",
  block,
  className,
  children,
  ...rest
}: ExternalButtonProps) {
  return (
    <a
      className={classFor(variant, block, className)}
      target="_blank"
      rel="noreferrer noopener"
      {...rest}
    >
      {children}
    </a>
  );
}
